import { useEffect, useState } from "react";

import { useForm, Controller } from "react-hook-form";
import { useLocation } from "react-router-dom";

import CloseIcon from "@mui/icons-material/Close";
import {
  Autocomplete,
  Box,
  Button,
  Modal,
  Switch,
  TextField,
  Typography,
} from "@mui/material";

import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import useGetElemDataById from "../../../hooks/useGetElemDataById";
import useGetUnlimitedListOf from "../../../hooks/useGetUnlimitedListOf";

const Update = ({ handleOpen, open, id }) => {
  const table = "Files"
  const axiosPrivate = useAxiosPrivate();
  const location = useLocation();

  const prev = useGetElemDataById(table, id,  "id");

  const [selecteduser_id, setSelecteduser_id] = useState();
  const [selectedfile_type_id, setSelectedfile_type_id] = useState();
  const [selectedpromotion_assignment_id, setSelectedpromotion_assignment_id] = useState();
  const usersTemp = useGetUnlimitedListOf("Users", "", "list");
  const usersData = usersTemp.listElements;

  const file_typesTemp = useGetUnlimitedListOf("File_Types", "", "list");
  const file_typesData = file_typesTemp.listElements;

  const promotion_assignmentsTemp = useGetUnlimitedListOf("Promotion_Assignments", "", "list");
  const promotion_assignmentsData = promotion_assignmentsTemp.listElements;

  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors },
  } = useForm();

useEffect(() => {
    if (prev) {
      if(prev.user_id) {
        setSelecteduser_id(prev.user_id);
        setValue("user_id", prev.user_id);
      }
      if(prev.file_type_id) {
        setSelectedfile_type_id(prev.file_type_id);
        setValue("file_type_id", prev.file_type_id);
      }
      if(prev.promotion_assignment_id) {
        setSelectedpromotion_assignment_id(prev.promotion_assignment_id);
        setValue("promotion_assignment_id", prev.promotion_assignment_id);
      }
    }
  }, [prev]);

  const update = async (data) => {
if (!data.user_id?.trim() || !data.file_type_id?.trim() || !data.path?.trim()) {
    window.alert("user_id, file_type_id, path non possono essere vuoti!");
    return;
  }


    const nullColumns = Object.keys(data)
    .filter(key => data[key] === null || data[key] === "")
    .join("|");

    const deletedData = data;
    delete deletedData.id;
    try {
      const updatedData = {
				id: prev.id,
        new_values: deletedData,
        str_list_null: nullColumns,
      };

      console.log(updatedData);

      const response = await axiosPrivate.put(`/${table}/update`, updatedData);
      if (response) {
        window.alert("Modifica avvenuta con successo!");
        window.location.reload();
      }
    } catch (err) {
      if (err.response?.status === 401) {
        window.location.href = "/unauthorized";
      } else {
        window.location.href = "/login";
      }
    }
  };

  if (prev.length !== 0) {
    return (
      <>

        <Modal open={open}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "80%",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              display: "flex",
              flexDirection: "column",
            }}
            alignItems={"center"}
          >
            <Box
              display={"flex"}
              justifyContent={"space-between"}
              sx={{ mb: 2 }}
            >
              <Typography
                id="keep-mounted-modal-title"
                variant="h6"
                component="h2"
              >
                Aggiorna l'elemento con id {id} alla tabella {table}
              </Typography>
              <Button
                color="error"
                onClick={() => handleOpen(false, "mod")}
                sx={{
                  maxWidth: "30px",
                  maxHeight: "30px",
                  minWidth: "30px",
                  minHeight: "30px",
                }}
              >
                <CloseIcon />
              </Button>
            </Box>
            {/* Autocomplete per il campo user_id */}
            <Autocomplete
              sx={{ width: "50%", m: 1 }}
              options={usersData}
              getOptionLabel={(option) => option.id || ""}
              value={
                selecteduser_id
                  ? usersData.find((user) => user.id === selecteduser_id)
                  : null
              }
              onChange={(event, newValue) => {
                if (newValue) {
                  setSelecteduser_id(newValue.id);
                  setValue("user_id", newValue.id);
                } else {
                  setSelecteduser_id(null);
                  setValue("user_id", "");
              }}}
              isOptionEqualToValue={(option, value) =>
                option.id === value.id
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select user_id"
                  placeholder="user_id"
                  error={!!errors.user_id}
                  helperText={
                    errors.user_id ? "Il campo user_id è obbligatorio" : ""
                  }
                  {...register("user_id")}
                />
              )}
            />
            {/* Autocomplete per il campo file_type_id */}
            <Autocomplete
              sx={{ width: "50%", m: 1 }}
              options={file_typesData}
              getOptionLabel={(option) => option.id || ""}
              value={
                selectedfile_type_id
                  ? file_typesData.find((file) => file.id === selectedfile_type_id)
                  : null
              }
              onChange={(event, newValue) => {
                if (newValue) {
                  setSelectedfile_type_id(newValue.id);
                  setValue("file_type_id", newValue.id);
                } else {
                  setSelectedfile_type_id(null);
                  setValue("file_type_id", "");
              }}}
              isOptionEqualToValue={(option, value) =>
                option.id === value.id
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select file_type_id"
                  placeholder="file_type_id"
                  error={!!errors.file_type_id}
                  helperText={
                    errors.file_type_id ? "Il campo file_type_id è obbligatorio" : ""
                  }
                  {...register("user_id")}
                />
              )}
            />
            {/* Autocomplete per il campo promotion_assignment_id */}
            <Autocomplete
              sx={{ width: "50%", m: 1 }}
              options={promotion_assignmentsData}
              getOptionLabel={(option) => option.id || ""}
              value={
                selectedpromotion_assignment_id
                  ? promotion_assignmentsData.find((promotion) => promotion.id === selectedpromotion_assignment_id)
                  : null
              }
              onChange={(event, newValue) => {
                if (newValue) {
                  setSelectedpromotion_assignment_id(newValue.id);
                  setValue("promotion_assignment_id", newValue.id);
                } else {
                  setSelectedpromotion_assignment_id(null);
                  setValue("promotion_assignment_id", "");
              }}}
              isOptionEqualToValue={(option, value) =>
                option.id === value.id
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select promotion_assignment_id"
                  placeholder="promotion_assignment_id"
                  error={!!errors.promotion_assignment_id}
                  helperText={
                    errors.promotion_assignment_id ? "Il campo promotion_assignment_id è obbligatorio" : ""
                  }
                  {...register("user_id")}
                />
              )}
            />
						{Object.entries(prev)
              .filter(([key]) => true && key !== "id" && key !== "user_id" && key !== "file_type_id" && key !== "promotion_assignment_id")
              .map(([key, value], index) => (
                <TextField
                  key={index}
                  placeholder={key}
                  defaultValue={value}
                  sx={{ width: "50%", m: 1 }}
                  {...register(key)}
                />
              ))}
            <Button onClick={handleSubmit(update)}>SALVA MODIFICHE</Button>
          </Box>
        </Modal>
      </>
    );
  }
};

export default Update;